<template>
<div class="s-canvas" @click="refreshCode">
    <canvas id="s-canvas" :width="contentWidth" :height="contentHeight"></canvas>
</div>
</template>

<script>
export default {
    name: "SIdentify",
	data() {
		return{
			identifyCode: "", // 需要展示的验证码
			codeLength: 4, // 取4位
			codeArr: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
		}
	},
    props: {
        // 字体大小（最小值）
        fontSizeMin: {
            type: Number,
            default: 26,
        },
        // 字体大小（最大值）
        fontSizeMax: {
            type: Number,
            default: 40,
        },
        // 背景颜色色值最小值，最小为0
        backgroundColorMin: {
            type: Number,
            default: 180,
        },
        // 背景颜色色值最大值，最小为255
        backgroundColorMax: {
            type: Number,
            default: 240,
        },
        // 字体颜色色值最小值，最小值为0
        colorMin: {
            type: Number,
            default: 50,
        },
        // 字体颜色色值最大值，最小为255
        colorMax: {
            type: Number,
            default: 160,
        },
        // 干扰线颜色色值最小值，最小为0
        lineColorMin: {
            type: Number,
            default: 40,
        },
        // 干扰线颜色色值最大值，最小为255
        lineColorMax: {
            type: Number,
            default: 180,
        },
        // 干扰点颜色色值最小值，最小为0
        dotColorMin: {
            type: Number,
            default: 0,
        },
        // 干扰点颜色色值最大值，最小为255
        dotColorMax: {
            type: Number,
            default: 255,
        },
        // 画布宽度
        contentWidth: {
            type: Number,
            default: 111,
        },
        // 画布高度
        contentHeight: {
            type: Number,
            default: 38,
        },
    },
    methods: {
        // 生成一个随机数
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        // 生成一个随机的颜色
        randomColor(min, max) {
            let r = this.randomNum(min, max);
            let g = this.randomNum(min, max);
            let b = this.randomNum(min, max);
            return "rgb(" + r + "," + g + "," + b + ")";
        },
        drawPic() {
            let canvas = document.getElementById("s-canvas");
            let ctx = canvas.getContext("2d");
            ctx.textBaseline = "bottom";
            // 绘制背景
            ctx.fillStyle = this.randomColor(
                this.backgroundColorMin,
                this.backgroundColorMax
            );
            ctx.fillRect(0, 0, this.contentWidth, this.contentHeight);
			console.log('画==',this.identifyCode)
            // 绘制文字
            for (let i = 0; i < this.identifyCode.length; i++) {
                this.drawText(ctx, this.identifyCode[i], i);
            }
            this.drawLine(ctx);
            this.drawDot(ctx);
        },
        drawText(ctx, txt, i) {
            ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax);
            ctx.font =
                this.randomNum(this.fontSizeMin, this.fontSizeMax) + "px SimHei";
            let x = (i + 1) * (this.contentWidth / (this.identifyCode.length + 1));
            let y = this.randomNum(this.fontSizeMax, this.contentHeight - 5);
            var deg = this.randomNum(-45, 45);
            // 修改坐标原点和旋转角度
            ctx.translate(x, y);
            ctx.rotate((deg * Math.PI) / 180);
            ctx.fillText(txt, 0, 0);
            // 恢复坐标原点和旋转角度
            ctx.rotate((-deg * Math.PI) / 180);
            ctx.translate(-x, -y);
        },
        drawLine(ctx) {
            // 绘制干扰线
            for (let i = 0; i < 0; i++) {
                ctx.strokeStyle = this.randomColor(
                    this.lineColorMin,
                    this.lineColorMax
                );
                ctx.beginPath();
                ctx.moveTo(
                    this.randomNum(0, this.contentWidth),
                    this.randomNum(0, this.contentHeight)
                );
                ctx.lineTo(
                    this.randomNum(0, this.contentWidth),
                    this.randomNum(0, this.contentHeight)
                );
                ctx.stroke();
            }
        },
        drawDot(ctx) {
            // 绘制干扰点
            for (let i = 0; i < 50; i++) {
                ctx.fillStyle = this.randomColor(0, 255);
                ctx.beginPath();
                ctx.arc(
                    this.randomNum(0, this.contentWidth),
                    this.randomNum(0, this.contentHeight),
                    1,
                    0,
                    2 * Math.PI
                );
                ctx.fill();
            }
        },
		refreshCode(){
			console.log('触发===')
			let numCode = "";
			for(let i = 0; i < this.codeLength; i++) {
				let charNum = Math.floor(Math.random() * this.codeArr.length);
				numCode += this.codeArr[charNum]
			}
			this.identifyCode = numCode;
			this.$emit('updateCode',numCode);
		}
    },
    watch: {
        identifyCode() {
			console.log('变化===')
            this.drawPic();
        },
    },
    mounted() {
		this.refreshCode();
        this.drawPic();
    },
};
</script>

<style scoped>
.s-canvas {
	width: 111px;
    height: 38px;
}

canvas {
    margin-top: 5px;
}
</style>
